import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { AbstractContainerJobTypeHelper } from '../../../../../../../shared/Container/Helper/AbstractContainerJobTypeHelper';
import { FreightPayer } from '../../../../../../../shared/freight-payers/models/FreightPayer';
import { LoadUnloadType } from '../../../../../../../shared/Container/model/LoadUnloadType';
import ContainerSize from '../../../../../../../shared/Container/model/ContainerSize';
import ContainerType from '../../../../../../../shared/Container/model/ContainerType';
import { Division } from '../../../../../../../shared/divisons/models/Division';
import { ContainerTypeEnum } from '../../../../../../../shared/Container/enum/ContainerTypeEnum';
import { DivisionManagementService } from '../../../../../../../shared/divisons/division.service';
import { ContainerService } from '../../../../../../../shared/Container/container.service';
import { CommonModule } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';
import { JobTypeEnum } from '../../../../../../../shared/Container/enum/JobTypeEnum';
import { JobType } from '../../../../../../../shared/Container/model/JobType';
import { BryntumGridModule } from '@bryntum/grid-angular';

@Component({
  selector: 'app-container-job-basics-form',
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule, NgSelectModule, BryntumGridModule],
  templateUrl: './container-job-basics-form.component.html',
  styleUrls: ['./container-job-basics-form.component.scss']
})
export class CreateContainerJobBasicsComponent implements OnInit, OnChanges {
    static selector = 'create-container-job-basics';

    abstractContainerJobTypeHelper: AbstractContainerJobTypeHelper = new AbstractContainerJobTypeHelper();

    @Input()
    formGroup!: FormGroup;

    @Input()
    freightPayers!: any[];

    @Input()
    loadUnloadTypes!: LoadUnloadType[];

    @Input()
    containerSizes!: ContainerSize[];

    @Input()
    containerTypes!: ContainerType[];

    @Input()
    divisions!: Division[];

    jobTypes: JobType[] = [];
    userDivison: Division | null = null;


    constructor(private containerJobService: ContainerService, private divisionManagementService: DivisionManagementService) { }

    ngOnChanges(changes: SimpleChanges): void {
      if(changes['freightPayers'] && this.freightPayers) {
        this.freightPayers = this.freightPayers.filter(payer => payer.isActive).map(payer => {
          return {
            name: payer.name,
            clienteleId: payer.clienteleId
          }
        });
      }
    }

    ngOnInit() {
        this.jobTypes = this.containerJobService.getJobTypes();

        if (!this.formGroup!.value.loadUnloadType) {
            // Set default load unload type to Not Applicable
            this.formGroup!.patchValue({ loadUnloadType: this.loadUnloadTypes[0] });
        }

        if (!this.formGroup!.value.containerType) {
            // Set default container type to general purpose
            this.formGroup!.patchValue({ containerType: this.containerTypes[0] });
        }

        if (!this.formGroup!.value.containerSize) {
            // Set default container size to 20ft
            this.formGroup!.patchValue({ containerSize: this.containerSizes[1] });
        }

        if (!this.formGroup!.value.billingDivision) {
            this.formGroup!.patchValue({ billingDivision: this.divisions[0] });
        }

        this.userDivison = this.divisionManagementService.getCurrentUserDivision();
    }

    getSelectedJobType = () => this.formGroup!.value.jobType ? this.formGroup!.value.jobType.id as JobTypeEnum : null;

    get liveLoadLabel(): string | null {
        const jobType = this.getSelectedJobType();
        if (jobType === JobTypeEnum.Import || jobType === JobTypeEnum.DomesticInbound) {
            return 'Live Unload';
        }
        if (jobType === JobTypeEnum.Export || jobType === JobTypeEnum.DomesticOutbound) {
            return 'Live Load';
        }
        return null;
    }

    isInitialized() {
        return this.freightPayers && this.loadUnloadTypes && this.containerSizes && this.containerTypes && this.jobTypes
    };

    showHighGauge(): boolean {
        return this.formGroup!.get('containerType')
            && this.formGroup!.get('containerType')!.value
            && (this.formGroup!.get('containerType')!.value.code === ContainerTypeEnum.OpenTop
                || this.formGroup!.get('containerType')!.value.code === ContainerTypeEnum.FlatRack)
    }

    showWideGauge(): boolean {
        return this.formGroup!.get('containerType')
            && this.formGroup!.get('containerType')!.value
            && (this.formGroup!.get('containerType')!.value.code === ContainerTypeEnum.FlatRack)
    }
}
